import { defineMessages } from 'react-intl';

export const messages: {
	fastLabel: { id: string; defaultMessage: string; description: string };
	selectModelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedModelAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasoningLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasoningDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fastLabel: {
		id: 'dtac.queryBuilder.queryAssistant.fast.ai-non-final',
		defaultMessage: 'Fast',
		description: 'Label for the fast query generation mode',
	},
	selectModelLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.selectModelLabel.non-final',
		defaultMessage: 'Select model',
		description: 'Accessible label for the model selection listbox.',
	},
	selectedModelAriaLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.selectedModelAriaLabel.non-final',
		defaultMessage: 'Model: {mode}',
		description: 'Accessible label for the currently selected model button.',
	},
	defaultLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.defaultLabel.non-final',
		defaultMessage: 'Default',
		description: 'Label for the default mode option.',
	},
	reasoningLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.reasoningLabel.non-final',
		defaultMessage: 'Reasoning',
		description: 'Label for the reasoning mode option.',
	},
	defaultDescription: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.defaultDescription.non-final',
		defaultMessage: 'Well rounded with a blend of accuracy and speed',
		description: 'Description for the default mode option.',
	},
	reasoningDescription: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.modeSelectorPopup.reasoningDescription.non-final',
		defaultMessage: 'Deeper reasoning for more complex requests',
		description: 'Description for the reasoning mode option.',
	},
});
